function TratPlaDemo({ demodata, id }) {
  return (
    <div className="smart-tag-bdy">
      <div className="smart-tag-bdy-rw">
        <span style={{ fontSize: '21px' }}>
          {demodata?.patientName} (#
          {demodata?.chartNo})
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.age} {demodata?.gender}
          {demodata?.dob && (
            <>
              ,&nbsp;<b>DOB</b>:{demodata?.dob}
            </>
          )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          <b>Address:</b>
          {demodata?.address && (
            <>
              <b>Address:</b> {demodata?.address}
            </>
          )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.email && (
            <>
              <b>Email</b>: {demodata?.email}
            </>
          )}
          {demodata?.phoneLabel && demodata?.phone && (
            <>
              ,&nbsp;<b>{demodata?.phoneLabel}</b>: {demodata?.phone}
            </>
          )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.race && (
            <>
              <b>Race</b>: {demodata?.race}
            </>
          )}
          {demodata?.raceGroup && (
            <>
              ,&nbsp;<b>Race</b>: {demodata?.raceGroup}
            </>
          )}
          {demodata?.ethincity && (
            <>
              ,&nbsp;<b>Race</b>: {demodata?.ethincity}
            </>
          )}
          {demodata?.ethincityGroup && (
            <>
              ,&nbsp;<b>Race</b>: {demodata?.ethincityGroup}
            </>
          )}
        </span>
      </div>
    </div>
  );
}

export default TratPlaDemo;
